const middleware = {}

middleware['authScope'] = require('../middleware/authScope.js')
middleware['authScope'] = middleware['authScope'].default || middleware['authScope']

middleware['championshipRegistrationForm'] = require('../middleware/championshipRegistrationForm.js')
middleware['championshipRegistrationForm'] = middleware['championshipRegistrationForm'].default || middleware['championshipRegistrationForm']

middleware['maintenance'] = require('../middleware/maintenance.js')
middleware['maintenance'] = middleware['maintenance'].default || middleware['maintenance']

middleware['redirectRoutesWithoutLocale'] = require('../middleware/redirectRoutesWithoutLocale.js')
middleware['redirectRoutesWithoutLocale'] = middleware['redirectRoutesWithoutLocale'].default || middleware['redirectRoutesWithoutLocale']

export default middleware
